import { EnergyType } from '../EnergyFlow'
import { InefficientProvider } from './common/InefficientProvider'
import { HourlyEnergyFlow } from '../HourlyEnergyFlow'

export class DistrictHeatingProvider extends InefficientProvider {
  public readonly providedEnergyTypes = [EnergyType.Heating]

  protected mapDemandToRequirementEnergyType(
    demand: HourlyEnergyFlow,
  ): EnergyType {
    return demand.energyType
  }

  protected mapDemandToWasteEnergyType(demand: HourlyEnergyFlow): EnergyType {
    return demand.energyType
  }
}
